// import React, { useState } from "react";
// import { useGlobalState } from "../GlobalProvider";
// import { useNavigate } from "react-router-dom";
// function Sidebar({ selectedMenu, selectedItem }) {
//   const navigate = useNavigate();
//   const { globalState, setGlobalState } = useGlobalState();
//   const [permissions, setPermissions] =useState(globalState?.user?.role?.permissions)
//   const navItem = [
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/1828/1828791.png",
//       menu: "Dashboard",
//       subMenu: [
//         {
//           name: "Dashboard",
//           path: "/",
//         },
//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/2435/2435245.png",
//       menu: "Order Management",
//       subMenu: [
//         {
//           name: "Orders",
//           path: "/order-list",
//         },
//         // {
//         //   name: "Bulk Order",
//         //   path: "/bulk-order-list",
//         // },
//       ],
//     },
    
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/2875/2875916.png",
//       menu: "Product Management",
//       subMenu: [
//         {
//           name: "Products",
//           path: "/product-list",
//         },
//         {
//           name: "Add Product",
//           path: "/add-product",
//         },
//         {
//           name: "Combo Packs",
//           path: "/combo-product-list",
//         },
//         {
//           name: "Add Combo Packs",
//           path: "/add-combo-product",
//         },
//         // {
//         //   name: "Product Types",
//         //   path: "/product-type-list",
//         // },
//         {
//           name: "Categories",
//           path: "/category-list",
//         },
//         {
//           name: "Brands",
//           path: "/brand-list"
//         },
//         {
//           name: "Tags",
//           path: "/tag-list",
//         },
//         // {
//         //   name: "Taxes",
//         //   path: "/tax-list",
//         // },
//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/1077/1077114.png",
//       menu: "User Management",
//       subMenu: [
//         {
//           name: "Users",
//           path: "/user-list",
//         },
//         {
//           name: "Premium Customer",
//           path: "/premium-user",
//         },
//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/535/535188.png",
//       menu: "Location Management",
//       subMenu: [
//         // {
//         //   name: "Pincode",
//         //   path: "/pin-code",
//         // },
//         {
//           name: "States",
//           path: "/state-list",
//         },
//         {
//           name: "City",
//           path: "/city-list",
//         },
//         // {
//         //   name: "Area",
//         //   path: "/area",
//         // },
//         {
//           name: "Bulk Upload",
//           path: "/bulk-upload",
//         },
//       ],
//     },
    
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/1601/1601521.png",
//       menu: "Banners",
//       subMenu: [
//         {
//           name: "Banners",
//           path: "/banner-list",
//         },
//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/2435/2435245.png",
//       menu: "Subscription",
//       subMenu: [
//         {
//           name: "Scheme",
//           path: "/scheme",
//         },
//         // {
//         //   name: "Chit Subscription",
//         //   path: "/subscription",
//         // },
//         {
//           name: "Chit User",
//           path: "/subscription-user",
//         },
//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/2840/2840215.png",
//       menu: "System Support",
//       subMenu: [
//         {
//           name: "FAQs",
//           path: "/faq-user-list",
//         },
//         {
//           name: "Contact Query",
//           path: "/contact-query",
//         },
//         {
//           name: "product Stock Query",
//           path: "/product-stock-query",
//         },
//         {name: "Pre-Book Query",
//           path: "/pre-book-query"
//         },
//          {
//       name: "Stock Banner",
//       path: "/stock-banner"
//     }

//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/6463/6463648.png",
//       menu: "Blog Management",
//       subMenu: [
//         {
//           name: "Blogs",
//           path: "/blogs-list",
//         },
//         {
//           name: "Add Blog",
//           path: "/add-blog",
//         },
//       ],
//     },
//     {
//       menuIcon: "https://cdn-icons-png.flaticon.com/128/2312/2312402.png",
//       menu: "Policy",
//       subMenu: [
//         {
//           name: "Cookie Policy",
//           path: "/user-cookie-policy",
//         },
//         {
//           name: "Privacy Policy",
//           path: "/user-privacy-policy",
//         },
//         {
//           name: "Shipping Policy",
//           path: "/user-shipping-policy",
//         },
//         {
//           name: "Terms & Condition",
//           path: "/user-terms-condition",
//         },
//         {
//           name: "Refund and Returns",
//           path: "/user-refund-return",
//         },
//       ],
//     },
//   ];

//   const [showMenu, setShowMenu] = useState(selectedMenu);
//   return (
//     <div
//       className={`sidebarMain ${
//         globalState?.showFullSidebar ? "sidebarVisible" : "sidebarHidden"
//       }`}
//     >
//       <div className="d-flex justify-content-end">
//         <img
//           className="d-block d-md-none mt-3 me-4"
//           style={{ height: "20px" }}
//           src="https://cdn-icons-png.flaticon.com/128/753/753345.png"
//           onClick={() =>
//             setGlobalState({ ...globalState, showFullSidebar: false })
//           }
//         />
//       </div>
//       <div className="p-3">
//         <div className="brandLogo d-flex justify-content-center align-items-center">
//           <img
//             className="img-fluid"
//             src="/bigBangLogo.webp"
//             alt="Logo"
//           />
//         </div>
//         <hr />
//         <div className="mt-3 ">
//           {navItem?.map((v, i) => {
//             return (
//               <div className="mb-4" onClick={() => setShowMenu(v?.menu)}>
//                 <div
//                   className="d-flex justify-content-between align-items-center mb-3 px-2 "
//                   style={{ opacity: "0.7", cursor: "pointer" }}
//                 >
//                   <div className="menuItem d-flex align-items-center">
//                     <img src={v?.menuIcon} />
//                     <p className="mb-0 ms-3">{v?.menu}</p>
//                   </div>
//                   <img
//                     className="dropIcon"
//                     src="https://cdn-icons-png.flaticon.com/128/6364/6364586.png"
//                   />
//                 </div>
//                 {showMenu == v?.menu && (
//                   <div className=" ms-4 ">
//                     {v?.subMenu?.map((v, i) => {
//                       return (
//                         <p
//                           style={{ cursor: "pointer" }}
//                           onClick={() => navigate(v?.path)}
//                           className={
//                             "mb-0 p-2 subMenu " +
//                             (v?.name == selectedItem
//                               ? " rounded  textPrimary "
//                               : " ")
//                           }
                          
//                         >
//                           <i className="fa fa-circle" /> {v?.name}
//                         </p>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Sidebar;


import React, { useState } from "react";
import { useGlobalState } from "../GlobalProvider";
import { useNavigate } from "react-router-dom";

function Sidebar({ selectedMenu, selectedItem }) {
  const navigate = useNavigate();
  const { globalState, setGlobalState } = useGlobalState();
  const [permissions, setPermissions] = useState(globalState?.user?.role?.permissions);

  const navItem = [
    {
      menuIcon: "ti-layout-dashboard",
      menu: "Dashboard",
      section: "Main",
      subMenu: [{ name: "Dashboard", path: "/" }],
    },
    {
      menuIcon: "ti-shopping-cart",
      menu: "Order Management",
      section: "Main",
      subMenu: [{ name: "Orders", path: "/order-list" }],
    },
    {
      menuIcon: "ti-box",
      menu: "Product Management",
      section: "Main",
      subMenu: [
        { name: "Products", path: "/product-list" },
        { name: "Add Product", path: "/add-product" },
        { name: "Combo Packs", path: "/combo-product-list" },
        { name: "Add Combo Packs", path: "/add-combo-product" },
        { name: "Categories", path: "/category-list" },
        { name: "Brands", path: "/brand-list" },
        { name: "Tags", path: "/tag-list" },
      ],
    },
    {
      menuIcon: "ti-users",
      menu: "User Management",
      section: "Management",
      subMenu: [
        { name: "Users", path: "/user-list" },
        { name: "Premium Customer", path: "/premium-user" },
      ],
    },
    {
      menuIcon: "ti-map-pin",
      menu: "Location Management",
      section: "Management",
      subMenu: [
        { name: "States", path: "/state-list" },
        { name: "City", path: "/city-list" },
        { name: "Bulk Upload", path: "/bulk-upload" },
      ],
    },
    {
      menuIcon: "ti-photo",
      menu: "Banners",
      section: "Management",
      subMenu: [
        { name: "Banners", path: "/banner-list" },
        { name: "Chit Banner", path: "/chit-banner" }
      ],
    },
    {
      menuIcon: "ti-refresh",
      menu: "Subscription",
      section: "Content & Support",
      subMenu: [
        { name: "Scheme", path: "/scheme" },
        { name: "Chit User", path: "/subscription-user" },
      ],
    },
    {
      menuIcon: "ti-headset",
      menu: "System Support",
      section: "Content & Support",
      subMenu: [
        { name: "FAQs", path: "/faq-user-list" },
        { name: "Contact Query", path: "/contact-query" },
        { name: "product Stock Query", path: "/product-stock-query" },
        { name: "Pre-Book Query", path: "/pre-book-query" },
        { name: "Stock Banner", path: "/stock-banner" },
      ],
    },
    {
      menuIcon: "ti-file-text",
      menu: "Blog Management",
      section: "Content & Support",
      subMenu: [
        { name: "Blogs", path: "/blogs-list" },
        { name: "Add Blog", path: "/add-blog" },
      ],
    },
    {
      menuIcon: "ti-shield",
      menu: "Policy",
      section: "Content & Support",
      subMenu: [
        { name: "Cookie Policy", path: "/user-cookie-policy" },
        { name: "Privacy Policy", path: "/user-privacy-policy" },
        { name: "Shipping Policy", path: "/user-shipping-policy" },
        { name: "Terms & Condition", path: "/user-terms-condition" },
        { name: "Refund and Returns", path: "/user-refund-return" },
      ],
    },
  ];

  const sections = ["Main", "Management", "Content & Support"];
  const [showMenu, setShowMenu] = useState(selectedMenu);

  return (
    <div
      className={`sidebarMain ${
        globalState?.showFullSidebar ? "sidebarVisible" : "sidebarHidden"
      }`}
    >
      {/* Mobile close */}
      <div className="sb-mobile-close d-flex d-md-none justify-content-end pt-3 pe-3">
        <button
          className="sb-close-btn"
          onClick={() => setGlobalState({ ...globalState, showFullSidebar: false })}
          aria-label="Close sidebar"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      {/* Logo */}
      <div className="sb-header">
        <div className="sb-logo-box">
          <img src="/bigBanglogo.png" alt="Logo" className="sb-logo-img" />
        </div>
        <div>
          <div className="sb-brand-name">BigBang</div>
          <div className="sb-brand-sub">Admin Panel</div>
        </div>
      </div>

      {/* Nav */}
      <div className="sb-nav-area">
        {sections.map((section) => (
          <div key={section}>
            <div className="sb-section-label">{section}</div>
            {navItem
              .filter((v) => v.section === section)
              .map((v, i) => (
                <div key={i} className="sb-menu-group">
                  <div
                    className={`sb-menu-header ${showMenu === v.menu ? "active" : ""}`}
                    onClick={() => setShowMenu(showMenu === v.menu ? null : v.menu)}
                  >
                    <div className="sb-icon-box">
                      <i className={`ti ${v.menuIcon}`} aria-hidden="true" />
                    </div>
                    <span className="sb-menu-label">{v.menu}</span>
                    <i
                      className={`ti ti-chevron-right sb-arrow ${
                        showMenu === v.menu ? "open" : ""
                      }`}
                      aria-hidden="true"
                    />
                  </div>

                  {showMenu === v.menu && (
                    <div className="sb-submenu">
                      {v.subMenu.map((sub, j) => (
                        <div
                          key={j}
                          className={`sb-sub-item ${sub.name === selectedItem ? "active" : ""}`}
                          onClick={() => navigate(sub.path)}
                        >
                          <span className="sb-sub-dot" />
                          {sub.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
          </div>
        ))}
      </div>

      {/* Footer */}
      {/* <div className="sb-footer">
        <div className="sb-avatar">AD</div>
        <div className="sb-user-info">
          <div className="sb-user-name">Admin</div>
          <div className="sb-user-role">Super Admin</div>
        </div>
        <i className="ti ti-logout sb-logout" aria-hidden="true" />
      </div> */}
    </div>
  );
}

export default Sidebar;